import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const PlanSelectionRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [approvingId, setApprovingId] = useState(null);

  useEffect(() => {
    loadRequests();
  }, []);

  const loadRequests = async () => {
    try {
      setLoading(true);
      const response = await api.getPlanSelectionRequests();
      if (response.success) {
        setRequests(response.data || []);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    if (!window.confirm('Approve this request and create a license?')) {
      return;
    }

    try {
      setApprovingId(id);
      const response = await api.approvePlanRequest(id, {
        start_date: new Date().toISOString().split('T')[0],
        expiry_date: (() => {
          const date = new Date();
          date.setMonth(date.getMonth() + 1);
          return date.toISOString().split('T')[0];
        })(),
      });

      if (response.success) {
        loadRequests();
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setApprovingId(null);
    }
  };

  const handleReject = async (id) => {
    const reason = window.prompt('Rejection reason:');
    if (!reason) return;

    try {
      const response = await api.rejectPlanRequest(id, { notes: reason });
      if (response.success) {
        loadRequests();
      } else {
        setError(response.message);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: 'bg-warning',
      approved: 'bg-success',
      rejected: 'bg-danger',
      completed: 'bg-info',
    };
    return badges[status] || 'bg-secondary';
  };

  if (loading) {
    return <div className="text-center p-4">Loading...</div>;
  }

  return (
    <>
      {error && (
        <div className="alert alert-danger alert-dismissible">
          <button type="button" className="close" onClick={() => setError('')}>&times;</button>
          {error}
        </div>
      )}

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Plan Selection Requests</h3>
            </div>
            <div className="card-body">
              <table className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Company</th>
                    <th>Tier</th>
                    <th>Contact</th>
                    <th>Billing</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {requests.length > 0 ? (
                    requests.map(request => (
                      <tr key={request.id}>
                        <td>{request.id}</td>
                        <td>{request.company_name}</td>
                        <td>
                          <span className="badge bg-info">{request.tier_name}</span>
                        </td>
                        <td>
                          <div style={{ fontSize: '10px' }}>
                            <div>{request.contact_name || 'N/A'}</div>
                            <div>{request.contact_email}</div>
                            {request.contact_phone && <div>{request.contact_phone}</div>}
                          </div>
                        </td>
                        <td>{request.billing_period}</td>
                        <td>
                          <span className={`badge ${getStatusBadge(request.status)}`}>
                            {request.status}
                          </span>
                        </td>
                        <td>{new Date(request.created_at).toLocaleDateString()}</td>
                        <td>
                          {request.status === 'pending' && (
                            <>
                              <button
                                className="btn btn-sm btn-success mr-1"
                                onClick={() => handleApprove(request.id)}
                                disabled={approvingId === request.id}
                              >
                                <i className="fas fa-check"></i> Approve
                              </button>
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleReject(request.id)}
                              >
                                <i className="fas fa-times"></i> Reject
                              </button>
                            </>
                          )}
                          {request.license_key && (
                            <div style={{ fontSize: '10px' }}>
                              <code>{request.license_key}</code>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">No requests found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PlanSelectionRequests;

